// Las dos vistas del banner horizontal del Inicio (grande 1920×320 y pequeña
// 960×240) y cómo se saca la pequeña de la grande. La lógica es la MISMA que
// usa la app: se importa su archivo tal cual (deja TCBannerViews en global),
// así el editor enseña exactamente lo que verá el usuario.
import '../../../renderer/tabs/inicio/componentes/banner-vistas.js';

export const BannerViews = globalThis.TCBannerViews;
